const doc = [({"ja":({"adminConstantHotelChildrenSearchDisplayType":({"all":"全て", "onlyAge":"年齢のみ表示", "onlyMealTypeAndBedding":"食事/寝具のみ表示"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;